/**
 * Derived sidecar builders attached to study envelopes on save. The markdown
 * twin (study.md) rides along on every put so hierarchical stores (Drive)
 * keep a human-inspectable copy next to study.json; the desktop shell renders
 * its own from the same @skjv/storage function, so both never drift.
 */

import type { Study } from '@skjv/common';
import {
  studyFolderName,
  studyMarkdown,
  studyMarkdownFileName,
  type StorageSidecar,
} from '@skjv/storage';

export function studyMarkdownSidecar(study: Study): StorageSidecar | null {
  try {
    const markdown = studyMarkdown(study);
    return {
      name: studyMarkdownFileName(studyFolderName(study)),
      blob: new Blob([markdown], { type: 'text/markdown' }),
      contentType: 'text/markdown',
    };
  } catch {
    return null;
  }
}
